import Vue from 'vue';
import './components/core';
import './components/common';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './lib/i18n';
import mapFilters from '@/lib/mapFilters';
import './filters';

import './scss/main.scss';
import '@/scss/blocks/tooltip.scss';

import VFocus from '@/directives/v-focus';
import VTooltip from '@/directives/v-tooltip';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
import Vue2TouchEvents from 'vue2-touch-events';

import 'svgxuse';

Vue.config.productionTip = false;

Vue.directive('focus', VFocus);
Vue.directive('tooltip', VTooltip);
Vue.use(VueDOMPurifyHTML);
Vue.use(Flicking);
Vue.use(Vue2TouchEvents);

Vue.mixin({
  methods: {
    ...mapFilters([
      'formatDate',
      'formatDateWithoutSpace',
      'formatDateTimeWithoutSecond',
      'formatCurrency'
    ])
  }
});

const orgTranslate = Object.getPrototypeOf(i18n)._translate;
Object.getPrototypeOf(i18n)._translate = function(
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  const namespacedKey = host?.$options?.i18nComponentKey
    ? [host.$options.i18nComponentKey, key].join('.')
    : host?.$options?.name
    ? [host.$options.name, key].join('.')
    : key;
  const message = store.state.translation.translations[namespacedKey];
  if (message !== undefined)
    return i18n._render(message, interpolateMode, args, namespacedKey);

  return orgTranslate.call(
    this,
    messages,
    locale,
    fallback,
    key,
    host,
    interpolateMode,
    args
  );
};

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
